import {formatDate} from '_components/admin/components/utils/helper';
import {Appointment, Client, ClientsDictionary} from './calendar.types';

// Group appointments by date MM/dd/yyyy
export const groupAppointmentsByDate = (
  appointments: Appointment[],
): Record<string, Appointment[]> => {
  return appointments.reduce((acc, appointment) => {
    const date = formatDate(new Date(appointment.dateOfAppointment));
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(appointment);
    return acc;
  }, {} as Record<string, Appointment[]>);
};

export const groupClientsById = (clients: Client[]): ClientsDictionary => {
  if (clients === undefined || !clients || !clients.length) return {};
  return clients.reduce<ClientsDictionary>((acc, client) => {
    acc[client.patientId] = client;
    return acc;
  }, {});
};
